import { createAction, props } from '@ngrx/store';
import {
  PagedFlightAudit,
  PagedFlightBusinessPersonAudit,
  PagedFlightCrewMemberAudit,
  PagedFlightCrewMemberCateringAudit,
  PagedFlightCrewMemberHotelAudit,
  PagedFlightCrewMemberTransportationAudit,
  PagedFlightPassengerAudit,
  PagedFlightPassengerCateringAudit,
  PagedFlightPassengerHotelAudit,
  PagedFlightPassengerTransportationAudit,
  PagedLegNoteAudit,
  PagedScheduledAircraftTripAudit,
  PagedScheduledAircraftTripSkeleton,
  PagedScheduledEventAudit,
  PagedScheduledFlightAudit,
  PagedFlightFuelAudit,
  ScheduledAircraftTripSkeleton,
  PagedAuditLogLite,
  DeletedTripItem,
  PagedDeletedTripLegs,
  PagedTripLegs,
  PagedFlightCrewMembers,
  PagedFlightPassengers,
  PagedFlightSchedulers
} from '../../+models/trip-audit.model';

export enum TripActionTypes {}

export const ResetDeletedScheduledTrip = createAction('[SharedAudit Trip] Reset');

export const LoadDeletedScheduledAircraftTripSkeletons = createAction(
  '[SharedAudit Trip] Load DeletedScheduledAircraftTrip Skeletons'
);

export const LoadNextPageDeletedScheduledAircraftTripSkeletons = createAction(
  '[SharedAUdit Trip] Load NextPage DeletedScheduledAircraftTrip Skeletons'
);

export const DeletedScheduledAircraftTripSkeletonsLoaded = createAction(
  '[SharedAudit Trip] DeletedScheduledAircraftTrip Skeletons Loaded',
  props<PagedScheduledAircraftTripSkeleton>()
);

export const DeletedScheduledAircraftTripSkeletonsLoadError = createAction(
  '[SharedAudit Trip] DeletedScheduledAircraftTrip Skeletons Load Error',
  props<{ err: any }>()
);

export const LoadScheduledAircraftTripSkeleton = createAction(
  '[SharedAudit Trip] Load ScheduledAircraftTrip Skeleton'
);

export const LoadScheduledTripV2Data = createAction(
  '[SharedAudit Trip] Load Scheduled Trip V2 Data'
);

export const ScheduledAircraftTripSkeletonLoaded = createAction(
  '[SharedAudit Trip] ScheduledAircraftTrip Skeleton Loaded',
  props<ScheduledAircraftTripSkeleton>()
);

export const ScheduledAircraftTripSkeletonLoadError = createAction(
  '[SharedAudit Trip] ScheduledAircraftTrip Skeleton Load Error',
  props<{ err: any }>()
);

export const LoadScheduledAircraftTripAudit = createAction(
  '[SharedAudit Trip] Load ScheduledAircraftTrip Audit',
  props<{ scheduledAircraftTripId: number }>()
);

export const LoadNextPageScheduledAircraftTripAudit = createAction(
  '[SharedAudit Trip] Load NextPage ScheduledAircraftTrip Audit',
  props<{ scheduledAircraftTripId: number }>()
);

export const ScheduledAircraftTripAuditLoaded = createAction(
  '[SharedAudit Trip] ScheduledAircraftTrip Audit Loaded',
  props<{ scheduledAircraftTripId: number; audits: PagedScheduledAircraftTripAudit }>()
);

export const ScheduledAircraftTripAuditLoadError = createAction(
  '[SharedAudit Trip] ScheduledAircraftTrip Audit Load Error',
  props<{ err: any }>()
);

export const LoadScheduledFlightAudit = createAction(
  '[SharedAudit Trip] Load ScheduledFlight Audit',
  props<{ scheduledFlightId: number }>()
);

export const LoadNextPageScheduledFlightAudit = createAction(
  '[SharedAudit Trip] Load NextPage ScheduledFlight Audit',
  props<{ scheduledFlightId: number }>()
);

export const ScheduledFlightAuditLoaded = createAction(
  '[SharedAudit Trip] ScheduledFlight Audit Loaded',
  props<{ scheduledFlightId: number; audits: PagedScheduledFlightAudit }>()
);

export const ScheduledFlightAuditLoadError = createAction(
  '[SharedAudit Trip] ScheduledFlight Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightAudit = createAction(
  '[SharedAudit Flight] Load Flight Audit',
  props<{ flightId: number }>()
);

export const LoadNextPageFlightAudit = createAction(
  '[SharedAudit Flight] Load NextPage Flight Audit',
  props<{ flightId: number }>()
);

export const FlightAuditLoaded = createAction(
  '[SharedAudit Flight] Flight Audit Loaded',
  props<{ flightId: number; audits: PagedFlightAudit }>()
);

export const FlightAuditLoadError = createAction(
  '[SharedAudit Flight] Flight Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightPassengerAudit = createAction(
  '[SharedAudit Trip] Load FlightPassenger Audit',
  props<{ flightPassengerId: number }>()
);

export const LoadNextPageFlightPassengerAudit = createAction(
  '[SharedAudit Trip] Load NextPage FlightPassenger Audit',
  props<{ flightPassengerId: number }>()
);

export const FlightPassengerAuditLoaded = createAction(
  '[SharedAudit Trip] FlightPassenger Audit Loaded',
  props<{ flightPassengerId: number; audits: PagedFlightPassengerAudit }>()
);

export const FlightPassengerAuditLoadError = createAction(
  '[SharedAudit Trip] FlightPassenger Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightPassengerCateringAudit = createAction(
  '[SharedAudit Trip] Load FlightPassengerCatering Audit',
  props<{ flightPassengerCateringId: number }>()
);

export const LoadNextPageFlightPassengerCateringAudit = createAction(
  '[SharedAudit Trip] Load NextPage FlightPassengerCatering Audit',
  props<{ flightPassengerCateringId: number }>()
);

export const FlightPassengerCateringAuditLoaded = createAction(
  '[SharedAudit Trip] FlightPassengerCatering Audit Loaded',
  props<{ flightPassengerCateringId: number; audits: PagedFlightPassengerCateringAudit }>()
);

export const FlightPassengerCateringAuditLoadError = createAction(
  '[SharedAudit Trip] FlightPassengerCatering Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightPassengerHotelAudit = createAction(
  '[SharedAudit Trip] Load FlightPassengerHotel Audit',
  props<{ flightPassengerHotelId: number }>()
);

export const LoadNextPageFlightPassengerHotelAudit = createAction(
  '[SharedAudit Trip] Load NextPage FlightPassengerHotel Audit',
  props<{ flightPassengerHotelId: number }>()
);

export const FlightPassengerHotelAuditLoaded = createAction(
  '[SharedAudit Trip] FlightPassengerHotel Audit Loaded',
  props<{ flightPassengerHotelId: number; audits: PagedFlightPassengerHotelAudit }>()
);

export const FlightPassengerHotelAuditLoadError = createAction(
  '[SharedAudit Trip] FlightPassengerHotel Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightPassengerTransportationAudit = createAction(
  '[SharedAudit Trip] Load FlightPassengerTransportation Audit',
  props<{ flightPassengerTransportationId: number }>()
);

export const LoadNextPageFlightPassengerTransportationAudit = createAction(
  '[SharedAudit Trip] Load NextPage FlightPassengerTransportation Audit',
  props<{ flightPassengerTransportationId: number }>()
);

export const FlightPassengerTransportationAuditLoaded = createAction(
  '[SharedAudit Trip] FlightPassengerTransportation Audit Loaded',
  props<{
    flightPassengerTransportationId: number;
    audits: PagedFlightPassengerTransportationAudit;
  }>()
);

export const FlightPassengerTransportationAuditLoadError = createAction(
  '[SharedAudit Trip] FlightPassengerTransportation Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightCrewMemberAudit = createAction(
  '[SharedAudit Trip] Load FlightCrewMember Audit',
  props<{ flightCrewMemberId: number }>()
);

export const LoadNextPageFlightCrewMemberAudit = createAction(
  '[SharedAudit Trip] Load NextPage FlightCrewMember Audit',
  props<{ flightCrewMemberId: number }>()
);

export const FlightCrewMemberAuditLoaded = createAction(
  '[SharedAudit Trip] FlightCrewMember Audit Loaded',
  props<{ flightCrewMemberId: number; audits: PagedFlightCrewMemberAudit }>()
);

export const FlightCrewMemberAuditLoadError = createAction(
  '[SharedAudit Trip] FlightCrewMember Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightCrewMemberCateringAudit = createAction(
  '[SharedAudit Trip] Load FlightCrewMemberCatering Audit',
  props<{ flightCrewMemberCateringId: number }>()
);

export const LoadNextPageFlightCrewMemberCateringAudit = createAction(
  '[SharedAudit Trip] Load NextPage FlightCrewMemberCatering Audit',
  props<{ flightCrewMemberCateringId: number }>()
);

export const FlightCrewMemberCateringAuditLoaded = createAction(
  '[SharedAudit Trip] FlightCrewMemberCatering Audit Loaded',
  props<{
    flightCrewMemberCateringId: number;
    audits: PagedFlightCrewMemberCateringAudit;
  }>()
);

export const FlightCrewMemberCateringAuditLoadError = createAction(
  '[SharedAudit Trip] FlightPassengerCatering Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightCrewMemberHotelAudit = createAction(
  '[SharedAudit Trip] Load FlightCrewMemberHotel Audit',
  props<{ flightCrewMemberHotelId: number }>()
);

export const LoadNextPageFlightCrewMemberHotelAudit = createAction(
  '[SharedAudit Trip] Load NextPage FlightCrewMemberHotel Audit',
  props<{ flightCrewMemberHotelId: number }>()
);

export const FlightCrewMemberHotelAuditLoaded = createAction(
  '[SharedAudit Trip] FlightCrewMemberHotel Audit Loaded',
  props<{ flightCrewMemberHotelId: number; audits: PagedFlightCrewMemberHotelAudit }>()
);

export const FlightCrewMemberHotelAuditLoadError = createAction(
  '[SharedAudit Trip] FlightCrewMemberHotel Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightCrewMemberTransportationAudit = createAction(
  '[SharedAudit Trip] Load FlightCrewMemberTransportation Audit',
  props<{ flightCrewMemberTransportationId: number }>()
);

export const LoadNextPageFlightCrewMemberTransportationAudit = createAction(
  '[SharedAudit Trip] Load NextPage FlightCrewMemberTransportation Audit',
  props<{ flightCrewMemberTransportationId: number }>()
);

export const FlightCrewMemberTransportationAuditLoaded = createAction(
  '[SharedAudit Trip] FlightCrewMemberTransportation Audit Loaded',
  props<{
    flightCrewMemberTransportationId: number;
    audits: PagedFlightCrewMemberTransportationAudit;
  }>()
);

export const FlightCrewMemberTransportationAuditLoadError = createAction(
  '[SharedAudit Trip] FlightCrewMemberTransportation Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightBusinessPersonAudit = createAction(
  '[SharedAudit Trip] Load FligtBusinessPerson Audit',
  props<{ flightBusinessPersonId: number }>()
);

export const LoadNextPageFlightBusinessPersonAudit = createAction(
  '[SharedAudit Trip] Load NextPage FligtBusinessPerson Audit',
  props<{ flightBusinessPersonId: number }>()
);

export const FlightBusinessPersonAuditLoaded = createAction(
  '[SharedAudit Trip] FligtBusinessPerson Audit Loaded',
  props<{ flightBusinessPersonId: number; audits: PagedFlightBusinessPersonAudit }>()
);

export const FlightBusinessPersonAuditLoadError = createAction(
  '[SharedAudit Trip] FligtBusinessPerson Audit Load Error',
  props<{ err: any }>()
);

export const LoadScheduledEventAudit = createAction(
  '[SharedAudit Trip] Load ScheduledEvent Audit',
  props<{ scheduledEventId: number }>()
);

export const LoadNextPageScheduledEventAudit = createAction(
  '[SharedAudit Trip] Load NextPage ScheduledEvent Audit',
  props<{ scheduledEventId: number }>()
);

export const ScheduledEventAuditLoaded = createAction(
  '[SharedAudit Trip] ScheduledEvent Audit Loaded',
  props<{ scheduledEventId: number; audits: PagedScheduledEventAudit }>()
);

export const ScheduledEventAuditLoadError = createAction(
  '[SharedAudit Trip] ScheduledEvent Audit Load Error',
  props<{ err: any }>()
);

export const LoadLegNoteAudit = createAction(
  '[SharedAudit Trip] Load LegNote Audit',
  props<{ legNoteId: number }>()
);

export const LoadNextPageLegNoteAudit = createAction(
  '[SharedAudit Trip] Load NextPage LegNote Audit',
  props<{ legNoteId: number }>()
);

export const LegNoteAuditLoaded = createAction(
  '[SharedAudit Trip] LegNote Audit Loaded',
  props<{ legNoteId: number; audits: PagedLegNoteAudit }>()
);

export const LegNoteAuditLoadError = createAction(
  '[SharedAudit Trip] LegNote Audit Load Error',
  props<{ err: any }>()
);

export const LoadFlightFuelAudit = createAction(
  '[SharedAudit Trip] Load FlightFuel Audit',
  props<{ flightFuelId: number }>()
);
export const LoadNextPageFlightFuelAudit = createAction(
  '[SharedAudit Trip] Load NextPage FlightFuel Audit',
  props<{ flightFuelId: number }>()
);

export const FlightFuelAuditLoaded = createAction(
  '[SharedAudit Trip] FlightFuel Audit Loaded',
  props<{ flightFuelId: number; audits: PagedFlightFuelAudit }>()
);

export const FlightFuelAuditLoadError = createAction(
  '[SharedAudit Trip] FlightFuel Audit Load Error',
  props<{ err: any }>()
);

// V2 Actions for lazy loading

// Deleted Trips V2
export const LoadDeletedTrips = createAction('[SharedAudit Trip V2] Load Deleted Trips');

export const LoadNextPageDeletedTrips = createAction(
  '[SharedAudit Trip V2] Load NextPage Deleted Trips'
);

export const DeletedTripsLoaded = createAction(
  '[SharedAudit Trip V2] Deleted Trips Loaded',
  props<{ totalCount: number; pageSize: number; pageNumber: number; resultSet: DeletedTripItem[] }>()
);

export const DeletedTripsLoadError = createAction(
  '[SharedAudit Trip V2] Deleted Trips Load Error',
  props<{ err: any }>()
);

// Trip Logs V2
export const LoadTripLogs = createAction(
  '[SharedAudit Trip V2] Load Trip Logs',
  props<{ tripId: number }>()
);

export const LoadNextPageTripLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Trip Logs',
  props<{ tripId: number }>()
);

export const TripLogsLoaded = createAction(
  '[SharedAudit Trip V2] Trip Logs Loaded',
  props<{ tripId: number; logs: PagedAuditLogLite }>()
);

export const TripLogsLoadError = createAction(
  '[SharedAudit Trip V2] Trip Logs Load Error',
  props<{ err: any }>()
);

// Deleted Trip Legs V2
export const LoadDeletedTripLegs = createAction(
  '[SharedAudit Trip V2] Load Deleted Trip Legs',
  props<{ tripId: number }>()
);

export const LoadNextPageDeletedTripLegs = createAction(
  '[SharedAudit Trip V2] Load NextPage Deleted Trip Legs',
  props<{ tripId: number }>()
);

export const DeletedTripLegsLoaded = createAction(
  '[SharedAudit Trip V2] Deleted Trip Legs Loaded',
  props<{ tripId: number; legs: PagedDeletedTripLegs }>()
);

export const DeletedTripLegsLoadError = createAction(
  '[SharedAudit Trip V2] Deleted Trip Legs Load Error',
  props<{ err: any }>()
);

// Trip Legs V2
export const LoadTripLegs = createAction(
  '[SharedAudit Trip V2] Load Trip Legs',
  props<{ tripId: number }>()
);

export const LoadNextPageTripLegs = createAction(
  '[SharedAudit Trip V2] Load NextPage Trip Legs',
  props<{ tripId: number }>()
);

export const TripLegsLoaded = createAction(
  '[SharedAudit Trip V2] Trip Legs Loaded',
  props<{ tripId: number; legs: PagedTripLegs }>()
);

export const TripLegsLoadError = createAction(
  '[SharedAudit Trip V2] Trip Legs Load Error',
  props<{ err: any }>()
);

// Leg Event Logs V2 (Dep/Arr Time)
export const LoadLegEventLogs = createAction(
  '[SharedAudit Trip V2] Load Leg Event Logs',
  props<{ eventId: number }>()
);

export const LoadNextPageLegEventLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Leg Event Logs',
  props<{ eventId: number }>()
);

export const LegEventLogsLoaded = createAction(
  '[SharedAudit Trip V2] Leg Event Logs Loaded',
  props<{ eventId: number; logs: PagedAuditLogLite }>()
);

export const LegEventLogsLoadError = createAction(
  '[SharedAudit Trip V2] Leg Event Logs Load Error',
  props<{ err: any }>()
);

// Leg Flight Logs V2 (Details)
export const LoadLegFlightLogs = createAction(
  '[SharedAudit Trip V2] Load Leg Flight Logs',
  props<{ flightId: number }>()
);

export const LoadNextPageLegFlightLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Leg Flight Logs',
  props<{ flightId: number }>()
);

export const LegFlightLogsLoaded = createAction(
  '[SharedAudit Trip V2] Leg Flight Logs Loaded',
  props<{ flightId: number; logs: PagedAuditLogLite }>()
);

export const LegFlightLogsLoadError = createAction(
  '[SharedAudit Trip V2] Leg Flight Logs Load Error',
  props<{ err: any }>()
);

// Leg Fuel Logs V2
export const LoadLegFuelLogs = createAction(
  '[SharedAudit Trip V2] Load Leg Fuel Logs',
  props<{ fuelId: number }>()
);

export const LoadNextPageLegFuelLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Leg Fuel Logs',
  props<{ fuelId: number }>()
);

export const LegFuelLogsLoaded = createAction(
  '[SharedAudit Trip V2] Leg Fuel Logs Loaded',
  props<{ fuelId: number; logs: PagedAuditLogLite }>()
);

export const LegFuelLogsLoadError = createAction(
  '[SharedAudit Trip V2] Leg Fuel Logs Load Error',
  props<{ err: any }>()
);

// Flight Crew Members
export const LoadFlightCrewMembers = createAction(
  '[SharedAudit Trip V2] Load Flight Crew Members',
  props<{ flightId: number }>()
);

export const LoadNextPageFlightCrewMembers = createAction(
  '[SharedAudit Trip V2] Load Next Page Flight Crew Members',
  props<{ flightId: number }>()
);

export const FlightCrewMembersLoaded = createAction(
  '[SharedAudit Trip V2] Flight Crew Members Loaded',
  props<{ flightId: number; data: PagedFlightCrewMembers }>()
);

export const FlightCrewMembersLoadError = createAction(
  '[SharedAudit Trip V2] Flight Crew Members Load Error',
  props<{ err: any }>()
);

export const LoadScheduledFlightCrewMembers = createAction(
  '[Trip] Load Scheduled Flight Crew Members',
  props<{ flightId: number }>()
);

export const LoadNextPageScheduledFlightCrewMembers = createAction(
  '[Trip] Load Next Page Scheduled Flight Crew Members',
  props<{ flightId: number }>()
);

// Crew Logs
export const LoadCrewLogs = createAction(
  '[SharedAudit Trip V2] Load Crew Logs',
  props<{ crewId: number }>()
);

export const LoadNextPageCrewLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Crew Logs',
  props<{ crewId: number }>()
);

export const CrewLogsLoaded = createAction(
  '[SharedAudit Trip V2] Crew Logs Loaded',
  props<{ crewId: number; logs: PagedAuditLogLite }>()
);

export const CrewLogsLoadError = createAction(
  '[SharedAudit Trip V2] Crew Logs Load Error',
  props<{ err: any }>()
);

// Crew Catering Logs
export const LoadCrewCateringLogs = createAction(
  '[SharedAudit Trip V2] Load Crew Catering Logs',
  props<{ cateringId: number }>()
);

export const LoadNextPageCrewCateringLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Crew Catering Logs',
  props<{ cateringId: number }>()
);

export const CrewCateringLogsLoaded = createAction(
  '[SharedAudit Trip V2] Crew Catering Logs Loaded',
  props<{ cateringId: number; logs: PagedAuditLogLite }>()
);

export const CrewCateringLogsLoadError = createAction(
  '[SharedAudit Trip V2] Crew Catering Logs Load Error',
  props<{ err: any }>()
);

// Crew Hotel Logs
export const LoadCrewHotelLogs = createAction(
  '[SharedAudit Trip V2] Load Crew Hotel Logs',
  props<{ hotelId: number }>()
);

export const LoadNextPageCrewHotelLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Crew Hotel Logs',
  props<{ hotelId: number }>()
);

export const CrewHotelLogsLoaded = createAction(
  '[SharedAudit Trip V2] Crew Hotel Logs Loaded',
  props<{ hotelId: number; logs: PagedAuditLogLite }>()
);

export const CrewHotelLogsLoadError = createAction(
  '[SharedAudit Trip V2] Crew Hotel Logs Load Error',
  props<{ err: any }>()
);

// Crew Transportation Logs
export const LoadCrewTransportationLogs = createAction(
  '[SharedAudit Trip V2] Load Crew Transportation Logs',
  props<{ transportationId: number }>()
);

export const LoadNextPageCrewTransportationLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Crew Transportation Logs',
  props<{ transportationId: number }>()
);

export const CrewTransportationLogsLoaded = createAction(
  '[SharedAudit Trip V2] Crew Transportation Logs Loaded',
  props<{ transportationId: number; logs: PagedAuditLogLite }>()
);

export const CrewTransportationLogsLoadError = createAction(
  '[SharedAudit Trip V2] Crew Transportation Logs Load Error',
  props<{ err: any }>()
);

// Flight Passengers
export const LoadFlightPassengers = createAction(
  '[SharedAudit Trip V2] Load Flight Passengers',
  props<{ flightId: number }>()
);

export const LoadNextPageFlightPassengers = createAction(
  '[SharedAudit Trip V2] Load Next Page Flight Passengers',
  props<{ flightId: number }>()
);

export const FlightPassengersLoaded = createAction(
  '[SharedAudit Trip V2] Flight Passengers Loaded',
  props<{ flightId: number; data: PagedFlightPassengers }>()
);

export const FlightPassengersLoadError = createAction(
  '[SharedAudit Trip V2] Flight Passengers Load Error',
  props<{ err: any }>()
);

export const LoadScheduledFlightPassengers = createAction(
  '[Trip] Load Scheduled Flight Passengers',
  props<{ flightId: number }>()
);

export const LoadNextPageScheduledFlightPassengers = createAction(
  '[Trip] Load Next Page Scheduled Flight Passengers',
  props<{ flightId: number }>()
);

// Passenger Logs
export const LoadPassengerLogs = createAction(
  '[SharedAudit Trip V2] Load Passenger Logs',
  props<{ paxId: number }>()
);

export const LoadNextPagePassengerLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Passenger Logs',
  props<{ paxId: number }>()
);

export const PassengerLogsLoaded = createAction(
  '[SharedAudit Trip V2] Passenger Logs Loaded',
  props<{ paxId: number; logs: PagedAuditLogLite }>()
);

export const PassengerLogsLoadError = createAction(
  '[SharedAudit Trip V2] Passenger Logs Load Error',
  props<{ err: any }>()
);

// Passenger Catering Logs
export const LoadPassengerCateringLogs = createAction(
  '[SharedAudit Trip V2] Load Passenger Catering Logs',
  props<{ cateringId: number }>()
);

export const LoadNextPagePassengerCateringLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Passenger Catering Logs',
  props<{ cateringId: number }>()
);

export const PassengerCateringLogsLoaded = createAction(
  '[SharedAudit Trip V2] Passenger Catering Logs Loaded',
  props<{ cateringId: number; logs: PagedAuditLogLite }>()
);

export const PassengerCateringLogsLoadError = createAction(
  '[SharedAudit Trip V2] Passenger Catering Logs Load Error',
  props<{ err: any }>()
);

// Passenger Hotel Logs
export const LoadPassengerHotelLogs = createAction(
  '[SharedAudit Trip V2] Load Passenger Hotel Logs',
  props<{ hotelId: number }>()
);

export const LoadNextPagePassengerHotelLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Passenger Hotel Logs',
  props<{ hotelId: number }>()
);

export const PassengerHotelLogsLoaded = createAction(
  '[SharedAudit Trip V2] Passenger Hotel Logs Loaded',
  props<{ hotelId: number; logs: PagedAuditLogLite }>()
);

export const PassengerHotelLogsLoadError = createAction(
  '[SharedAudit Trip V2] Passenger Hotel Logs Load Error',
  props<{ err: any }>()
);

// Passenger Transportation Logs
export const LoadPassengerTransportationLogs = createAction(
  '[SharedAudit Trip V2] Load Passenger Transportation Logs',
  props<{ transportationId: number }>()
);

export const LoadNextPagePassengerTransportationLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Passenger Transportation Logs',
  props<{ transportationId: number }>()
);

export const PassengerTransportationLogsLoaded = createAction(
  '[SharedAudit Trip V2] Passenger Transportation Logs Loaded',
  props<{ transportationId: number; logs: PagedAuditLogLite }>()
);

export const PassengerTransportationLogsLoadError = createAction(
  '[SharedAudit Trip V2] Passenger Transportation Logs Load Error',
  props<{ err: any }>()
);

// --- Tier-1: Flight Schedulers ---
export const LoadFlightSchedulers = createAction(
  '[SharedAudit Trip V2] Load Flight Schedulers',
  props<{ flightId: number }>()
);
export const LoadNextPageFlightSchedulers = createAction(
  '[SharedAudit Trip V2] Load Next Page Flight Schedulers',
  props<{ flightId: number }>()
);
export const FlightSchedulersLoaded = createAction(
  '[SharedAudit Trip V2] Flight Schedulers Loaded',
  props<{ flightId: number; data: PagedFlightSchedulers }>()
);
export const FlightSchedulersLoadError = createAction(
  '[SharedAudit Trip V2] Flight Schedulers Load Error',
  props<{ err: any }>()
);

// Scheduled-trip variant (calls the non-deleted endpoint, reuses FlightSchedulersLoaded)
export const LoadScheduledFlightSchedulers = createAction(
  '[Trip] Load Scheduled Flight Schedulers',
  props<{ flightId: number }>()
);
export const LoadNextPageScheduledFlightSchedulers = createAction(
  '[Trip] Load Next Page Scheduled Flight Schedulers',
  props<{ flightId: number }>()
);

// --- Tier-2: Scheduler Logs ---
export const LoadSchedulerLogs = createAction(
  '[SharedAudit Trip V2] Load Scheduler Logs',
  props<{ schedulerId: number }>()
);
export const LoadNextPageSchedulerLogs = createAction(
  '[SharedAudit Trip V2] Load NextPage Scheduler Logs',
  props<{ schedulerId: number }>()
);
export const SchedulerLogsLoaded = createAction(
  '[SharedAudit Trip V2] Scheduler Logs Loaded',
  props<{ schedulerId: number; logs: PagedAuditLogLite }>()
);
export const SchedulerLogsLoadError = createAction(
  '[SharedAudit Trip V2] Scheduler Logs Load Error',
  props<{ err: any }>()
);
